import { FC } from "react";
import AppRoutes from ".";
import Navbar from "../components/Navbar";
import SideNav from "../components/SideNav";

const AppLayout: FC = () => {
  return (
    <div className="flex min-h-screen">
      <SideNav>
        <Navbar />
        <div>
          <AppRoutes />
        </div>
      </SideNav>
    </div>
  );
};

export default AppLayout;
